import { CONTRIBUTING_CAMPAIGNS_ERROR_TEXT } from 'modules/intelligentInsights/brandAffinityInsights/constants';
import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { ErrorStatePageError } from 'ui/illustrations';
import { colors, spacing } from 'ui/theme';
import { TextButton } from 'ui/button';
import { FC } from 'react';

const Wrapper = styled.div`
  padding: ${spacing.x3} 0;
`;
const DescriptionWrapper = styled.span`
  color: ${colors.textSecondary};
`;
const StyledTextButton = styled(TextButton)`
  padding: 0 ${spacing.quarter};
`;

export const ContributingCampaignsErrorId = 'contributing-campaigns-error';
export interface ContributingCampaignsErrorProps {
  onRefresh?: () => void;
}
export const ContributingCampaignsError: FC<ContributingCampaignsErrorProps> = ({ onRefresh }) => (
  <Wrapper data-error="true" data-test={ContributingCampaignsErrorId}>
    <EmptyState
      Illustration={ErrorStatePageError}
      title="We’ve hit a snag"
      data-test="contributing-campaigns-error-state"
      subtitle={
        <DescriptionWrapper>
          {CONTRIBUTING_CAMPAIGNS_ERROR_TEXT}
          <StyledTextButton
            onClick={() => {
              onRefresh?.();
            }}
          >
            try refreshing the page.
          </StyledTextButton>
        </DescriptionWrapper>
      }
    />
  </Wrapper>
);
